<template>
    <footer class="footer-area section_gap">
    <div class="container">
        <div class="row">
        <div class="col-lg-6 col-md-6 single-footer-widget">
          <h4>Quick  Links</h4>
          <ul>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/faq">Frequently Asked Questions</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
          </ul>
        </div>
        <div class="col-lg-6 col-md-6 single-footer-widget">
          <h4>Contact Address</h4>

           <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-email"></i></span>
            <div class="media-body">
              <p class="text-white">info@sanitizerwristbands.com</p>
              <p>Send us your query anytime!</p>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom row align-items-center">
        <p class="footer-text m-0 col-lg-8 col-md-12"><!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
      <Copyright/>
<!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. --></p>
        <!--div class="col-lg-4 col-md-12 footer-social">
          <a href="#"><i class="fa fa-facebook"></i></a>
          <a href="#"><i class="fa fa-twitter"></i></a>
          <a href="#"><i class="fa fa-dribbble"></i></a>
          <a href="#"><i class="fa fa-behance"></i></a>
        </div-->
      </div>
    </div>
  </footer>
</template>
<script>
import Copyright from '@/components/Copyright'
export default {
  components: {
    Copyright
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppFooter.vue